// extracted by mini-css-extract-plugin
export default {"homePageBlock":"HomePageblock_homePageBlock__wMbqz","homePageBlockImage":"HomePageblock_homePageBlockImage__+EXRd","homePageBlockText":"HomePageblock_homePageBlockText__3JGnt"};